import React from 'react';
import { Phone, MapPin } from "lucide-react";


const ContactInfo = ({ icon: Icon, title, details }) => (
  <div className="bg-white rounded-lg shadow-md p-6 transform hover:scale-105 transition-transform duration-300">
    <div className="flex items-center mb-4">
      <span className="text-3xl mr-3 text-gray-800">
        <Icon color="#ef4444"/>
      </span>
      <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
    </div>
    {details.map((detail, index) => {
      const [name, phone] = detail.split(':').map((s) => s.trim());
      return (
        <p key={index} className="text-gray-600 mb-2">
          {name} {phone ? ":" : ""}{" "}
          {phone && (
            <a href={`tel:${phone}`} className="text-blue-600 hover:underline">
              {phone}
            </a>
          )}
        </p>
      );
    })}
  </div>
);


const ContactPage = () => {
  return (
    <div>
      <div className="max-w-7xl mx-auto pt-5">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-extrabold text-gray-900 mb-4">Contact us</h1>
          <p className="text-xl text-gray-600">We're here to help and answer any question you might have</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-center">
          <ContactInfo
            icon={Phone}
            title="Game Information"
            details={[
              "Prof. J. G. Tank: +91 800094459",
              "Pankaj Sir Dave: +91 8320318803",
              "Ghanshyam Sir Zala: +91 9924600211",
            ]}
          />
          <ContactInfo
            icon={Phone}
            title="Tech Support"
            details={[
              "Technical Support: +91 7096412310",
              "Technical Support: +91 9925913386",
              "Technical Support: +91 6354545353",
            ]}
          />

            <ContactInfo
            icon={MapPin}
            title="Location"
            details={[
              "A-110 Sport Room",
              "Rajkot - Morbi Highway",
              "Gujarat-363650, INDIA"
            ]}
          />
        </div>
        <div className="mt-16 rounded-lg shadow-lg overflow-hidden mb-20">
          <div className="bg-gradient-to-b from-[#190003] to-red-500 p-8 sm:p-10">
            <h3 className="text-2xl font-bold text-white mb-4">
              Developed By TopGrowth IT Solution
            </h3>
            <p className="text-white/80 mb-6">
              Let's discuss how TopGrowth can help transform your ideas into reality. 
              Reach out to us today and take the first step towards a more innovative future.
            </p>
            <button 
              onClick={() => window.open('https://topgrowth.in')}
              className="bg-white text-red-500 font-bold py-3 px-6 rounded-lg hover:bg-red-50 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Topgrowth.in
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;

